import { Rnd } from "react-rnd";
import Paper from "@mui/material/Paper";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect, useCallback } from "react";

const Modal = (props) => {
  // Calculate center position when the component mounts
  const calcCenterPos = useCallback(() => ({
    x: (window.innerWidth - props?.initialWidth) / 2,
    y: (window.innerHeight - props?.initialHeight) / 2
  }), [props?.initialHeight, props?.initialWidth]);

  const [size, setSize] = useState({ width: props?.initialWidth, height: props?.initialHeight });
  const [position, setPosition] = useState(calcCenterPos());

  // Reset position/size when modal opens
  useEffect(() => {
    if (props.open) {
      setSize({ width: props?.initialWidth, height: props?.initialHeight });
      setPosition(calcCenterPos());
    }
  }, [props.open, calcCenterPos, props?.initialHeight, props?.initialWidth]);

  if (!props.open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)", // backdrop
        zIndex: 1300,
        borderRadius: "5px"
      }}
      onClick={props.handleClose}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <Rnd
          size={size}
          position={position}
          disableDragging={true} // ✅ no drag move
          enableResizing={{
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
          }}
          onResizeStop={(e, direction, ref, delta, pos) => {
            setSize({
              width: parseInt(ref.style.width, 10),
              height: parseInt(ref.style.height, 10)
            });
            setPosition(pos);
          }}
          style={{
            background: "white",
            borderRadius: 6
          }}
        >
          <Paper
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              borderRadius: "5px"
            }}
          >
            <DialogTitle
              style={{
                background: "#f5f5f5",
                borderBottom: "1px solid #ddd"
              }}
            >
              {props.title}
              <IconButton
                aria-label="close"
                onClick={props.handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500]
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent
              dividers
              sx={{
                flex: 1,
                overflow: "hidden",
                padding: 0,
                display: 'flex',          // allow inner content to flex
                flexDirection: 'column'
              }}
            >
              {typeof props.content === 'function'
                ? props.content(size.height)
                : props.content}
            </DialogContent>
            <DialogActions>{props.action}</DialogActions>
          </Paper>
        </Rnd>
      </div>
    </div>
  );
};

export default Modal;